import React from 'react';
import _ from 'underscore';
import {connect} from 'react-redux';
import { useParams } from 'react-router-dom';
import Lightbox from '../components/Lightbox/Lightbox';
import {
    getAuctionUrl,
    getAuctionLightboxUrl
} from '../utils/urls';
import {
    getTransform,
    OBJECT_AUCTION
} from '../utils/sources';

const getTitleForIndex = (auctionData, photoIndex, total) => (
    !auctionData || !auctionData.title
        ? 'Auction Image'
        : `photo #${photoIndex + 1} of ${total} for auction: ${auctionData.title}`
);

const ConnectedLightbox = connect(
    (state, { auctionId, photoId }) => {
        if (!photoId) {
            throw new Error('Make a better error here.  Probably have the lightbox handle failure by showing something pretty');
        }

        let transform = getTransform(OBJECT_AUCTION);
        let auctionData = transform(state.auction.data) || {};
        let photos = auctionData.photos || [];

        let photoIndex = _(photos)
            .findIndex(photo => photo.id === photoId);

        let photo = photos[photoIndex] || {};

        let title = getTitleForIndex(auctionData, photoIndex, photos.length);

        let nextImage;
        let previousImage;

        if (photos.length > 1) {
            let nextIndex = photoIndex + 1 < photos.length ? photoIndex + 1 : 0;
            let previousIndex = photoIndex - 1 >= 0 ? photoIndex - 1 : photos.length - 1;

            nextImage = {
                url: getAuctionLightboxUrl(
                    auctionId,
                    photos[nextIndex].id
                ),
                title: getTitleForIndex(auctionData, nextIndex, photos.length)
            };
            previousImage = {
                url: getAuctionLightboxUrl(
                    auctionId,
                    photos[previousIndex].id
                ),
                title: getTitleForIndex(auctionData, previousIndex, photos.length)
            }

        }


        return ({
            imageSrc: photo.url,
            imageAlt: title,
            imageTitle: title,
            closeUrl: getAuctionUrl(auctionId),

            nextImage,
            previousImage
        })
    }
)(Lightbox);

// Wrapper component that extracts params and passes them to connected component
function AuctionLightboxContainer(props) {
    const { auctionId, photoId } = useParams();
    return React.createElement(ConnectedLightbox, Object.assign({}, props, { auctionId: auctionId, photoId: photoId }));
}

export default AuctionLightboxContainer;
